import { ReactNode } from "react";

export const ClinicalCaseTopInfoCard = ({
  title,
  mainContent,
  subText,
  icon,
}: {
  title: string;
  mainContent: string;
  subText: string;
  icon: ReactNode;
}) => {
  return (
    <div className="border-base flex-1 rounded-xl border p-4 md:p-6">
      <p className="mb-2 flex justify-between gap-2">
        <span className="text-sm font-medium">{title}</span>
        <span className="h-4 w-4">{icon}</span>
      </p>
      <p className="text-2xl font-bold">{mainContent}</p>
      <p className="text-xs text-[#71717A]">{subText}</p>
    </div>
  );
};
